module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_intro_list03-1fd57c2483f927869f81dd3bf8103218.png";